/**
 * Ai-Tools Frontend MCP Server Connector
 * Securely communicates with the VPS-hosted Model Context Protocol server.
 */

// We assume the MCP VPS proxy is running at this public IP and Port 3000
const MCP_ENDPOINT = "http://98.159.110.115:3000";

// Usually, this API key should be injected securely or passed by Auth
const MCP_API_KEY = "REPLACE_WITH_YOUR_MCP_SECRET_IN_ENV";

let sessionId: string | null = null;

export class MCPClient {
  static async connect() {
    console.log("[MCP] Attempting connection via SSE...");

    const source = new EventSource(`${MCP_ENDPOINT}/sse`);

    return new Promise((resolve, reject) => {
      source.onmessage = (event) => {
        try {
          const parsed = JSON.parse(event.data);
          console.log("[MCP SSE Message]", parsed);
          // Standard MCP protocol initializes by passing the session endpoint URI
          if (parsed.type === "endpoint" && parsed.uri) {
            sessionId = new URL(parsed.uri).searchParams.get("sessionId");
            console.log(`[MCP] Active Session ID established: ${sessionId}`);
            resolve(sessionId);
          }
        } catch (e) {
          console.error("Failed to parse SSE event", event.data);
        }
      };

      source.onerror = (err) => {
        console.error("[MCP] SSE Connection Error:", err);
        reject(err);
      };
    });
  }

  static async callTool(toolName: string, args: Record<string, any>) {
    if (!sessionId) {
      throw new Error("Cannot call tool: Session ID is missing. Call MCPClient.connect() first.");
    }

    console.log(`[MCP] Dispatching Tool Request: ${toolName}`);

    const response = await fetch(`${MCP_ENDPOINT}/messages?sessionId=${sessionId}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${MCP_API_KEY}`
      },
      body: JSON.stringify({
        jsonrpc: "2.0",
        id: crypto.randomUUID(),
        method: "tools/call",
        params: {
          name: toolName,
          arguments: args
        }
      })
    });

    if (!response.ok) {
      throw new Error(`MCP Server responded with status: ${response.status}`);
    }

    return response.json();
  }
}
